(function () {
class $cc6886241b8c6e07$var$ProductDetailsCard {
    constructor(el){
        this.el = el;
        this.variantSelector = this.el.querySelector(".product-variant-selector");
        this.backorderConfirmation = this.el.querySelector(".backorder-confirmation");
        this.variants = this.variantSelector ? Array.from(this.variantSelector.querySelectorAll("option")) : null;
        this.priceEl = this.el.querySelector(".price-item--regular");
        this.salePriceEl = this.el.querySelector(".price-item--sale");
        this.submit = this.el.querySelector(`button`);
        this.init();
    }
    init() {
        if (this.backorderConfirmation != null) {
            this.submit.setAttribute("disabled", "");
            this.backorderConfirmation.addEventListener("change", ()=>{
                if (this.backorderConfirmation.checked) this.submit.removeAttribute("disabled");
                else this.submit.setAttribute("disabled", "");
            });
        }
        if (this.variantSelector != null && this.variants.length > 0) this.variantSelector.addEventListener("change", ()=>{
            const v = this.variantSelector.value;
            const o = this.variants.find((c)=>c.value == v);
            this.priceEl.innerText = o.dataset.price;
            if (o.dataset.salePrice != "" && o.dataset.salePrice != null && this.salePriceEl != null) this.salePriceEl.innerText = o.dataset.salePrice;
        });
        this.el.classList.add("initialized");
    }
}
window.addEventListener("DOMContentLoaded", ()=>{
    const cards = document.querySelectorAll(".product-details-card");
    cards.forEach((c)=>{
        new $cc6886241b8c6e07$var$ProductDetailsCard(c);
    });
});

})();
//# sourceMappingURL=productDetailsCard.js.map
